module.exports = __webpack_public_path__ + "img/other1.0ccf751.png";